import React, {useContext, useEffect, useState} from 'react';
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import Slider from "react-slick";
import {useParams} from "react-router-dom";
import {handleImageUrl} from "../helpers";
import 'react-datepicker/dist/react-datepicker.css';
import {axios} from "../axios";
import {LangContext} from "../App";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Seo from "../components/Seo/Seo";
import {faLocationDot, faStar} from "@fortawesome/free-solid-svg-icons";
import Callback from "../components/CallBack/Callback";

const RestaurantSingle = () => {
    const id = useParams().id
    const [data,setData] = useState()
    const lang = useContext(LangContext)
    useEffect(()=>{
        axios.get(`${lang}/restaurant/${id}`)
            .then(res => setData(res.data))
            .catch(() => setData(null))
    },[id,lang])

    const [sliderSettings,setSlidersettings] = useState({
        dots: true,
        infinite: true,
        speed: 500,
        arrows:false,
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical:false,
        customPaging: (i) => <div style={{backgroundImage:`url(${i})`}}></div>,
    })
    useEffect(()=>{
        let images = data?.images?.split(',')
        if(images){
            images.pop()
            let sliderData = {...sliderSettings,customPaging:(i) => {
                    return (
                        <div style={{backgroundImage: `url(${handleImageUrl(images[i])})`}}></div>
                    )
                }}
            setSlidersettings(sliderData)
        }


    // eslint-disable-next-line react-hooks/exhaustive-deps -- loop
    },[data])
    const handleSliderImages = ()=>{
        let images = data?.images?.split(',')
        if(images){
            images?.pop()
            return images.map((img, idx) => {
                return (
                    <div key={idx} className='slider-image-wrapper' style={{borderRadius:'0 !important'}}>
                        <img src={handleImageUrl(img)} alt={data?.title} style={{borderRadius:'0 !important'}}/>
                    </div>
                )
            })
        }
    }
    return (
        <div className='tour-page'>
            <Seo
                pageKey="restaurants"
                title={data?.title}
                description={data?.description?.replace(/<[^>]*>?/gm, '').substring(0, 160)}
            />
            <div className="center-wrapper">
                <main>
                    <div className="row w-100">
                        <div className="col-12">
                            <div className="tour-info">
                                <h1 className="tour-title">{data?.title}</h1>
                                <div className="stars">
                                    <div className="star me-3">
                                        <FontAwesomeIcon icon={faStar}/> - {data?.stars}
                                    </div>
                                    <div className="star">
                                        <FontAwesomeIcon icon={faLocationDot}/> - {data?.city}
                                    </div>
                                </div>
                                <div className="tour-image version-2" style={{borderRadius:'0'}}>
                                    <Slider {...sliderSettings}>
                                        {handleSliderImages()}
                                    </Slider>
                                </div>
                                <div className="row">
                                    <div className="col-8">
                                        <div className="d-flex flex-column tour-details">
                                            <p>
                                                <b>Country: </b>{data?.country}
                                            </p>
                                            <p>
                                                <b>Address: </b>{data?.address}
                                            </p>
                                            <p>
                                                <b>City: </b>{data?.city}
                                            </p>
                                        </div>
                                        <div className="main-text" dangerouslySetInnerHTML={{__html:data?.text}}></div>
                                    </div>
                                    <div className="col-4">
                                        <Callback title='Book a table' tourType='restaurant' tourId={data?.id}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default RestaurantSingle;